import moment from "moment";
import { isToday } from "../utils";

export const REQUIRED_MESSAGE = "This field is required";

const DAY_BOOKING_NOTICE = 2;

const AVAILABLE_CITIES = [
  "Oakley",
  "Whitchurch",
  "Steventon",
  "North Waltham",
  "Dummer",
  "Wootton Saint Lawrence",
  "Ashford Hill",
  "Inkpen",
  "Basingstoke",
  "Hook",
  "Odiham",
  "Oakley",
  "Sherborne St John",
];

export const required = (messageText = null, options = null) => {
  const config = options || {};

  return {
    ...config,
    rules: [
      {
        required: true,
        message: messageText || REQUIRED_MESSAGE,
      },
    ],
  };
};

export const validateEmail = () => ({
  rules: [
    {
      type: "email",
      message: "Please input a valid email address",
    },
    {
      required: true,
      message: REQUIRED_MESSAGE,
    },
  ],
});

export const validateHasTimesAvailable = (
  date,
  unavailableDays,
  allTimes = []
) => {
  const now = moment();
  const day = date.day();

  if (day === 6 || day === 0) {
    return false;
  }

  if (now.diff(date, "days") >= 0) {
    return false;
  }

  if (isToday(date)) {
    return false;
  }

  if (date < now) {
    return false;
  }

  if (!allTimes.length) {
    return false;
  }

  if (unavailableDays.includes(date.format("D"))) {
    return false;
  }

  if (date.unix() <= moment().add(DAY_BOOKING_NOTICE, "day").unix()) {
    return false;
  }

  return true;
};

export const validateContactNumber = () => ({
  rules: [
    {
      required: true,
      message: REQUIRED_MESSAGE,
    },
    {
      validator: (rule, value, callback) => {
        const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;

        if (value) {
          if (reg.test(value) || value.length <= 9) {
            return callback("Please enter a valid contact number");
          }
        }

        return callback();
      },
    },
  ],
});

export const validatePostcode = () => ({
  rules: [
    {
      required: true,
      message: REQUIRED_MESSAGE,
    },
    {
      validator: (rule, value, callback) => {
        const reg = /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/;

        if (value) {
          if (!reg.test(value)) {
            return callback("Please enter a valid postcode");
          }
        }

        return callback();
      },
    },
  ],
});

export const validateCity = ({ city }) => {
  // Do not validate cities.

  // const formattedCities = AVAILABLE_CITIES.map((city) => city.toLowerCase());

  // if (!formattedCities.includes(city.toLowerCase())) {
  //   return (
  //     `Sorry, we're currently not accepting bookings in this town / city at the moment. ` +
  //     `Our primary locations are ${AVAILABLE_CITIES.join(", ")}.`
  //   );
  // }

  return null;
};

export const validateConfirmEmail = (emailAddress) => ({
  rules: [
    {
      required: true,
      message: REQUIRED_MESSAGE,
    },
    {
      validator: (rule, value, callback) => {
        if (value && value !== emailAddress) {
          return callback("Email addresses do not match");
        }

        return callback();
      },
    },
  ],
});

export const validateFullName = (fullName) => ({
  rules: [
    {
      required: true,
      message: REQUIRED_MESSAGE,
    },
    {
      min: 4,
      message: "Minimum length 4 characters",
    },
  ],
});
